import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../assets/img/logo.jpg';

const ErrorPageComponent = () => {
  return (
    <div id="main">
      <div className="fof">
        <h1>Error 404</h1>
        <p>Vrati se na početnu stranicu &#9759;</p>
        <Link to="/">
          <img src={Logo} alt="Logo" />
        </Link>
      </div>
    </div>
  );
};

export default ErrorPageComponent;
